import { useEffect, useState } from "react";
import PromotionHeader from "../../components/Promotion/PromotionHeader";
import PromotionTable from "../../components/Promotion/PromotionTable";
import { fetchAllPromos } from "../../services/promoServices";
import { useNavigate } from "react-router-dom";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";

const Promotion = () => {
  const [promos, setPromos] = useState([]);
  const navigate = useNavigate();
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [isTableDataLoading, setTableLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [totalCount, setTotalCount] = useState(0);
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    search: "",
    isActive: "",
  });

  useEffect(() => {
    fetchPromos(params);
  }, []);

  const fetchPromos = async (params: any) => {
    setTableLoader(true);
    try {
      let { data } = await fetchAllPromos(params);
      setPromos(data?.data);
      setTotalCount(data?.total);
    } catch (error: any) {
      setTableLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    } finally {
      setTableLoader(false);
    }
  };

  const handleEdit = (id: string) => {
    navigate(`/admin/edit-promo/${id}`);
  };

  const handlePageChange = (page: any) => {
    let paramsClone = { ...params };
    paramsClone.page = page;
    setParams(paramsClone);
    fetchPromos(paramsClone);
  };

  const handleSearch = (e: any) => {
    let paramsClone = { ...params };
    paramsClone.search = e;
    paramsClone.page = 1;
    setParams(paramsClone);
    fetchPromos(paramsClone);
  };

  const handleTypeChange = (e: any) => {
    let val = e.target.value;
    console.log(val);

    let paramsClone = { ...params };
    paramsClone.isActive = val;
    paramsClone.page = 1;
    setParams(paramsClone);
    fetchPromos(paramsClone);
  };

  return (
    <>
      <PromotionHeader
        onSearch={handleSearch}
        searchQuery={params.search}
        type={params.isActive}
        onTypeChange={handleTypeChange}
      />
      <PromotionTable
        isTableDataLoading={isTableDataLoading}
        data={promos}
        onEdit={handleEdit}
        currentPage={params.page}
        totalData={totalCount}
        rowsPerPage={params.limit}
        onPageChange={handlePageChange}
      />
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
    </>
  );
};

export default Promotion;
